import { Common, Accessors } from "../../../../helper";

const studentColumns = [
  {
    Header: "",
    accessor: Accessors.Action,
  },
  {
    Header: Common.SurName,
    accessor: Accessors.LastName,
  },
  {
    Header: Common.ForeName,
    accessor: Accessors.FirstName,
  },
  {
    Header: Common.Characteristics,
    accessor: Accessors.OtherNeeds,
  },
  {
    Header: Common.Upn,
    accessor: Accessors.Upn,
  },
  {
    Header: Common.SchoolYear,
    accessor: Accessors.Year,
  },
  {
    Header: Common.Gender,
    accessor: Accessors.Gender,
  },
];

export { studentColumns };
